/** A programmer error inside sim, hosts or schema: the match must abort (docs/ARCHITECTURE.md §13). */
export class InvariantViolation extends Error {
  override readonly name = 'InvariantViolation'
}
